import styled from 'styled-components';
import SkeletonBox from 'conversations-skeleton-state/components/SkeletonBox';
import SkeletonCircle from 'conversations-skeleton-state/components/SkeletonCircle';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ReassignmentSelectInput = styled.div.withConfig({
  displayName: "ReassignmentSelectInputPlaceholder__ReassignmentSelectInput",
  componentId: "bnmc82-0"
})(["padding:0 10px 0 0;width:150px;height:24px;display:flex;align-items:center;"]);
const Details = styled.div.withConfig({
  displayName: "ReassignmentSelectInputPlaceholder__Details",
  componentId: "bnmc82-1"
})(["display:flex;flex-direction:column;justify-content:space-around;width:100%;height:100%;"]);
const ReassignmentSelectInputPlaceholder = () => /*#__PURE__*/_jsxs(ReassignmentSelectInput, {
  disabled: true,
  "data-test-id": "reassignment-select-placeholder",
  children: [/*#__PURE__*/_jsx(SkeletonCircle, {
    size: 24,
    className: "m-right-1"
  }), /*#__PURE__*/_jsx(Details, {
    children: /*#__PURE__*/_jsx(SkeletonBox, {
      width: "100%",
      height: "0.75em"
    })
  })]
});
ReassignmentSelectInputPlaceholder.displayName = 'ReassignmentSelectInputPlaceholder';
export default ReassignmentSelectInputPlaceholder;